import exportacao from './exportacao'
import procedimentoConsolidado from './procedimentoConsolidado'
import procedimentoIndividualizado from './procedimentoIndividualizado'
import relatorioBpaConsolidado from './relatorioBpaConsolidado'
import relatorioBpaIndividualizado from './relatorioBpaIndividualizado'
import relatorioInconsistencia from './relatorioInconsistencia'
import relatorioQuantitativoProducao from './relatorioQuantitativoProducao'

export default [
    {
        path: 'bpa',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...exportacao,
            ...procedimentoConsolidado,
            ...procedimentoIndividualizado,
            ...relatorioBpaConsolidado,
            ...relatorioBpaIndividualizado,
            ...relatorioInconsistencia,
            ...relatorioQuantitativoProducao,
        ]
    }
]